import Vue from 'vue'
import Component from 'vue-class-component'
import { Store } from 'vuex'
import RootState from '../../store/state'
import { SsoItem } from '../../api/kajiki/account'
import { AccountData } from '../../store/manager/state'
import isBrowserIE from '../../misc/is-browser-ie'

interface ActionMap {
  [key: string]: string
}

const ACTION_MAP: ActionMap = {
  manageFaq: 'https://secure.okbiz.okwave.jp/faq-e-seikatsu/faq/show/5258?&site_domain=default',
  editorFaq: 'https://secure.okbiz.okwave.jp/faq-e-seikatsu/faq/show/5252?site_domain=default'
}

@Component({
  props: {
    action: {
      type: String,
      required: true
    }
  }
})
export default class HelpPageLinkVue extends Vue {
  name: 'helpPageLink'
  $store: Store<RootState>
  readonly action: string
  readonly linkTarget = 'supportsite'

  get accountData(): AccountData | undefined {
    return this.$store.state.manager.accountData
  }

  get ssoData(): SsoItem | undefined {
    return this.accountData ? this.accountData.sso : undefined
  }

  get actionUrl(): string {
    return ACTION_MAP[this.action] || ''
  }

  get form(): HTMLFormElement {
    return <HTMLFormElement>this.$el
  }

  openFaq(): void {
    if (!this.actionUrl) {
      throw new Error(`action の指定が不正なため、FAQに遷移できませんでした: ${this.action}`)
    }
    // formからの送信時には ShiftJISでURLエンコードして送る必要がある。
    // 基本的にはformタグに accept-charset属性に Shift_JIS を指定すればエンコードが出来る。
    // IEでは上記対応が効かないため、submit時にJavaScriptで一時的にdocumentのエンコードを ShiftJIS に変える。
    if (isBrowserIE()) {
      const originCharset = document.charset
      document.charset = 'Shift-JIS'
      this.form.submit()
      document.charset = originCharset
      return
    }

    this.form.submit()
  }
}
